import { VACANCY_STATUS, MapVacancyType } from 'domain/shared/newVacancy';

export function isMoveDisabled(
  vacancy: MapVacancyType,
  openVacanciesCount: number,
  totalVacanciesCount: number,
  hasActiveApplications: boolean,
  hasActivePublications: boolean,
) {
  const isLastVacancy = totalVacanciesCount === 1;

  switch (vacancy.status) {
    case VACANCY_STATUS.REQUIRES_REVIEW:
    case VACANCY_STATUS.CLOSED:
      return true;

    case VACANCY_STATUS.OPEN: {
      const isOnlyOpenVacancy = openVacanciesCount === 1;
      const hasNoBlockingDependencies = !hasActiveApplications && !hasActivePublications;

      if (!isOnlyOpenVacancy) return false;

      const canMove = hasNoBlockingDependencies || (isLastVacancy && hasNoBlockingDependencies);
      return !canMove;
    }

    case VACANCY_STATUS.CANCELLED:
    case VACANCY_STATUS.EXPIRED:
      return isLastVacancy && (hasActiveApplications || hasActivePublications);

    default:
      return true;
  }
}

/**
 * Returns an array of reasons (plain strings) why a job cannot be moved.
 */
export function getMoveDisabledReasons(
  vacancy: MapVacancyType,
  isLastVacancy: boolean,
  hasActiveApplications: boolean,
  hasActivePublications: boolean,
): string[] {
  const reasons: string[] = [];

  if (vacancy.status === VACANCY_STATUS.REQUIRES_REVIEW) {
    reasons.push('Cannot move this vacancy, as it requires review.');
  }

  if (vacancy.status === VACANCY_STATUS.CLOSED) {
    reasons.push('Cannot move this vacancy, as it is closed.');
  }

  if (vacancy.status === VACANCY_STATUS.OPEN) {
    if (hasActiveApplications) {
      reasons.push("Cannot move this vacancy, as it's the last open vacancy with active applications.");
    }
    if (hasActivePublications) {
      reasons.push("Cannot move this vacancy, as it's the last open vacancy with active publications.");
    }
  }

  if ([VACANCY_STATUS.CANCELLED, VACANCY_STATUS.EXPIRED].includes(vacancy.status) && isLastVacancy) {
    if (hasActiveApplications) {
      reasons.push("Cannot move this vacancy, as it's the last one in the group with active applications.");
    }
    if (hasActivePublications) {
      reasons.push("Cannot move this vacancy, as it's the last one in the group with active publications.");
    }
  }

  return reasons;
}
